import store from "../vuex/store";
let isIosCache = null;
export function isIos() {
  if (isIosCache !== null) {
    return isIosCache;
  } else {
    const u = window.navigator.userAgent;
    const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    isIosCache = isiOS;
    return isiOS;
  }
}

export const isSubsOffer = offer => {
  //判断这个offer是否是订阅类型的offer
  try {
    let result;
    if (offer.kind.indexOf("vip") > -1) {
      return true;
      // result = !GeneralUtilsHelper.getIapTypeByServiceOffer(offer.offer_id);
    } else {
      result = offer.hasOwnProperty("subscription");
    }
    return result;
  } catch (error) {
    return false;
  }
};

export const getConactUrl = () => {
  let u = navigator.userAgent;
  let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
  let kg = "%20";
  let hc = "%0A";
  let title = "";
  let osName = "";
  let start =
    "Hi,%0APlease let us know if you have any problem.(here)%0A%0A%0A%0A%0A";
  if (isAndroid) {
    title = "Web Android Instagram 1.0.0";
    osName = "Android";
  } else {
    title = "Web iOS Instagram 1.0.0 ";
    osName = "iOS";
  }
  let body =
    "Hi," +
    hc +
    "Please let us know if you have any problem." +
    hc +
    "(here)" +
    hc +
    hc +
    hc +
    hc +
    "Paypal" +
    kg +
    "Account:" +
    hc +
    "App" +
    kg +
    "Version: 1.0" +
    hc +
    "Username:" +
    kg +
    "" +
    hc +
    "User" +
    kg +
    "Master_ID:" +
    kg +
    store.state.masterId +
    hc +
    "User" +
    kg +
    "Agent:" +
    kg +
    navigator.userAgent;
  return "mailto:support@followersmania.com?subject=" + title + "&body=" + body;
};

export const offerToKindDesc = offer => {
  if (offer) {
    switch (offer.kind) {
      case "follow": {
        return "Followers";
        break;
      }
      case "golden_follow": {
        return "Golden Followers";
        break;
      }
      case "like": {
        return "Likes";
        break;
      }
      case "comment": {
        return "Comments";
        break;
      }
      case "view": {
        return "Views";
        break;
      }
      case "vip": {
        return "VIP";
        break;
      }
      default:
        break;
    }
    //订阅类型：
    if (offer.kind.includes("subs_like")) {
      return "Subs Likes";
    } else if (offer.kind.includes("subs_follow")) {
      return "Subs Followers";
    }
  } else {
    return "";
  }
};

export const paymentReultTranlateData = result => {
  if (result) {
    const offer = result.offer_data;
    const { resource } = result;
    const kindDesc = offerToKindDesc(offer);
    const effect = offer.effect;
    let userPicUrl = "";
    if (isSubsOffer(offer) || !isPostType(offer)) {
      userPicUrl = resource && resource.profile_pic_url;
    } else {
      userPicUrl = resource && resource.image_thumb;
    }

    return {
      userPicUrl,
      kindDesc,
      effect
    };
  } else {
    return null;
  }
};

export function timestampToTime(timestamp) {
  if (timestamp === null || timestamp === undefined) {
    return "";
  }
  const date = new Date(
    timestamp.toString().length === 10 ? timestamp * 1000 : timestamp
  ); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
  const addZero = number => {
    return number < 10 ? "0" + number : number;
  };
  const Y = date.getFullYear() + "-";
  const M =
    (date.getMonth() + 1 < 10
      ? "0" + (date.getMonth() + 1)
      : date.getMonth() + 1) + "-";
  const D = addZero(date.getDate()) + " ";
  const h = addZero(date.getHours()) + ":";
  const m = addZero(date.getMinutes()) + ":";
  const s = addZero(date.getSeconds());
  return Y + M + D + h + m + s;
}

export function isPostType(offer) {
  return (
    offer.kind.includes("like") ||
    offer.kind.includes("comment") ||
    offer.kind.includes("view")
  );
}

export function creatUUid() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx"
    .replace(/[xy]/g, c => {
      const r = (Math.random() * 16) | 0;
      const v = c === "x" ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    })
    .toUpperCase();
}

/**
 * offer_id 相同则订阅过 , subscribed:true 没有订阅过，当时定的
 * @param {*} subs_arr
 * @param {*} service_list
 */
export const filterSubsArray = (period_type, service_list, subs_arr) => {
  const filterArray = subs_arr
    .filter(item => {
      return item.subscription.period_type === period_type;
    })
    .map(item => {
      for (let service of service_list) {
        if (service.offer_id && service.offer_id === item.offer_id) {
          return {
            ...item,
            subscribed: false
          };
          break;
        }
      }
      return {
        ...item,
        subscribed: true
      };
    });
  return filterArray;
};



// WEBPACK FOOTER //
// ./src/utils/lodash.js